import "./AboutAIB.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import About from "./sections/About";
import MeetThePlayExperts from "./sections/MeetThePlayExperts";
import InformativeFooter from "@/reusable_sections/Footer";
export default function AboutAIBPage() {
  return <div>
      <FraternalExcellenceHeader />
      <About />
      <MeetThePlayExperts />
      <InformativeFooter />
    </div>;
}